import { render, staticRenderFns } from "./BecomeCreatorStatus.vue?vue&type=template&id=59d3283c&scoped=true&"
import script from "./BecomeCreatorStatus.vue?vue&type=script&lang=ts&"
export * from "./BecomeCreatorStatus.vue?vue&type=script&lang=ts&"
import style0 from "./BecomeCreatorStatus.vue?vue&type=style&index=0&id=59d3283c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d3283c",
  null
  
)

export default component.exports